"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var VerticalLodgingCard_1 = tslib_1.__importDefault(require("./VerticalLodgingCard"));

var HorizontalLodgingCard_1 = tslib_1.__importDefault(require("./HorizontalLodgingCard"));

var CardLink_1 = tslib_1.__importDefault(require("../../CardLink"));

function LodgingCard(_a) {
  var _a$type = _a.type,
      type = _a$type === void 0 ? 'vertical' : _a$type,
      aTagAttrs = _a.aTagAttrs,
      href = _a.href,
      isCSRLink = _a.isCSRLink,
      cardData = tslib_1.__rest(_a, ["type", "aTagAttrs", "href", "isCSRLink"]);

  return jsx_runtime_1.jsxs(CardLink_1.default, Object.assign({}, aTagAttrs, {
    isCSRLink: isCSRLink,
    href: href || (aTagAttrs ? aTagAttrs.href : '')
  }, {
    children: [type === 'vertical' && jsx_runtime_1.jsx(VerticalLodgingCard_1.default, Object.assign({}, cardData), void 0), type === 'horizontal' && jsx_runtime_1.jsx(HorizontalLodgingCard_1.default, Object.assign({}, cardData), void 0)]
  }), void 0);
}

exports.default = LodgingCard;